module.exports = "/static/assets/14120e6444ca2744dad272d8ca2a4646.svg";